module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-left-4.d50b58d2.png";